import { Component, Input } from '@angular/core';
import { NavController, Keyboard, Events } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { ApiProvider } from '../../providers/api/api';
import { AnalyticsProvider } from '../../providers/analytics/analytics';

@Component({
  selector: 'common-footer',
  templateUrl: 'common-footer.html',
})
export class CommonFooterComponent {
  @Input() page:string;
  @Input() site_flg:boolean;
  @Input() shop_data = [];
  is_pc:boolean;
  service_data = [];
  footer_list = [];
  background_color:string = '#4e8ef7';
  is_android:boolean;
  drawer_list = [];
  year:number;
  is_coupon_badge:boolean;
  company_name:string;

  constructor(
    public navCtrl: NavController,
    public keyboard: Keyboard,
    public events: Events,
    public comProv: CommonProvider,
    public apiProv: ApiProvider,
    public gaProv: AnalyticsProvider,
  ) {
    this.is_pc = this.comProv.isPc();
    this.service_data = this.comProv.getService();
    this.is_android = this.comProv.isAndroid();
    this.year = (new Date()).getFullYear();

    this.company_name = this.service_data['name'];
    if (this.service_data['company_name']) {
      this.company_name = this.service_data['company_name'];
    }

    this.events.subscribe('drawer:set', () => {
      this.setDrawer();
    });
  }

  ngOnInit() {
    this.setList();
    this.setDrawer();
  }

  setDrawer() {
    this.drawer_list = this.comProv.getDrawer();
    this.drawer_list = this.drawer_list.filter(item => item['is_privated'] != 1);
    let info_rule = {title:'規約',page_target:'InfoRulePage'};
    let info_privacy = {title:'プライバシーポリシー',page_target:'InfoPrivacyPage'};
    this.drawer_list.push(info_rule);
    this.drawer_list.push(info_privacy);
  }

  setList() {
    if (!localStorage.getItem('footer_list') || localStorage.getItem('footer_list') == '') {
      return;
    }
    let footer_color = '#ffffff';
    if (localStorage.getItem('footer_color')) {
      footer_color = localStorage.getItem('footer_color');
    }
    let footer_inactive_color = '#b3b3b3';
    if (localStorage.getItem('footer_inactive_color')) {
      footer_inactive_color = localStorage.getItem('footer_inactive_color');
    }
    if (localStorage.getItem('footer_background_color')) {
      this.background_color = localStorage.getItem('footer_background_color');
    }

    let footer_list = JSON.parse(localStorage.getItem('footer_list'));
    for (let i=0; i<footer_list.length; i++) {
      if (footer_list[i]['target'] == this.page) {
        footer_list[i]['text_color'] = footer_color;
      } else {
        footer_list[i]['text_color'] = footer_inactive_color;
      }
      if (footer_list[i]['icon']) {
        footer_list[i]['icon'] = footer_list[i]['icon'].replace('fab ', 'fab-tenpo ');
      }
    }
   
    this.footer_list = footer_list;
    this.setCouponBadge();
  }

  goPage(item) {
    let data = {
      url: item['url'],
      target: item['target'],
      current_page: this.page,
      category: 'フッターメニュー'
    };
    this.comProv.goPage(data, this.navCtrl, this.gaProv);
  }

  goPagePc(item) {
    this.comProv.goPagePc(item, this.navCtrl, this.page);

    /*if (item['page_url']) {
      this.comProv.checkLink(item['page_url'], this.navCtrl);
    } else if (item['page_target'] == 'HomePage') {
      this.navCtrl.setRoot('home');
    } else if (item['page_target'].indexOf('FreeIndexPage-') === 0) {
      let targets = item['page_target'].split('-');
      this.navCtrl.setRoot(targets[0], {free_id:targets[1]});
    } else if (item['is_scroll']) {
      this.scrollTo(item['page_target']);
    } else if (item['page_target']) {
      this.navCtrl.setRoot(item['page_target']);
    }*/
  }

  /*scrollTo(id) {
    if (this.page == 'HomePage') {
      let element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
      } 
    } else {
      this.navCtrl.setRoot('home',{scroll_id:id});
    }
  }*/

  mouseOver(item) {
    let color_list = this.comProv.getColor();

    item['color'] = color_list['button_background'];
  }

  mouseOut(item) {
    item['color'] = '#000000';
  }

  checkCouponBadge() {
    let find_coupon = this.footer_list.findIndex((footer_data) => {
      return (footer_data['target'] == 'CouponIndexPage');
    });
    if (find_coupon === -1) {
      return false;
    }
    return true;
  }

  setCouponBadge() {
    if (!this.checkCouponBadge()) {
      return;
    }

    // クーポンバッジ削除
    if (this.page == 'CouponIndexPage') {
      this.comProv.setOptions('is_coupon_badge', 0);
      this.comProv.setOptions('last_coupon_display_time', this.comProv.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss'));
      return;
    }

    if (this.comProv.getOptionsValue('is_coupon_badge')) {
      this.is_coupon_badge = true;
    }
  }

  getLatestCoupon() {
    if (!this.checkCouponBadge()) {
      return;
    }

    this.apiProv.get(this.service_data['_links']['latest_coupon']['href'])
      .then(data => {
        if (data['statusCode'] != '000') {
          this.apiProv.detaError(data);
          return;
        }
        let latest_coupon_at = data['latest_coupon_at'];
        //console.log('latest_coupon_at', latest_coupon_at);
        if (!latest_coupon_at) {
          this.comProv.setOptions('is_coupon_badge', 0);
          return;
        }

        let last_coupon_display_time = this.comProv.getOptionsValue('last_coupon_display_time');
        //console.log('last_coupon_display_time', last_coupon_display_time);
        let is_coupon_badge = this.comProv.checkTime(last_coupon_display_time, latest_coupon_at);
        if (is_coupon_badge) {
          this.is_coupon_badge = true;
          this.comProv.setOptions('is_coupon_badge', 1);
        }

    }).catch(error => {
      //this.apiProv.statusError(error, this.navCtrl);
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/common-footer/common-footer.ts